import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IOrderModel } from 'src/app/appModels/IOrderModel';

@Injectable({
  providedIn: 'root'
})
export class CheckoutHelper {

  tipAmount = new BehaviorSubject(0);
  tipToggleVal = new BehaviorSubject<any>(null); // Tip Toggle Val is help to reset Tip amount or remove tip
  tax = new BehaviorSubject<any | null>(null);

  activeOrderId = new BehaviorSubject<number | null>(2669);

  totalAmount = new BehaviorSubject<number>(0);



}  